import * as React from "react"
import Svg, { SvgProps, Mask, Path } from "react-native-svg"
const DiamondIconv2 = (props: SvgProps) => (
  <Svg
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <Mask id="a" fill="#fff">
      <Path
        fillRule="evenodd"
        d="M0 11.001c6.106 0 11.056-4.925 11.056-11V0v.002c0 6.033 4.881 10.93 10.929 11-6.047.068-10.928 4.966-10.928 10.998C11.056 15.926 6.106 11.002 0 11.002V11Z"
        clipRule="evenodd"
      />
    </Mask>
    <Path
      fill="#000"
      d="M0 11.001v-1h-1v1h1ZM11.056 0v-1h-1v1h1Zm0 0h1v-1h-1v1Zm10.929 11.001.011 1v-2l-.011 1ZM11.057 22v1h1v-1h-1Zm0 0h-1v1h1v-1ZM0 11.002h-1v1h1v-1ZM0 12c6.654 0 12.056-5.368 12.056-12h-2c0 5.518-4.497 10-10.056 10v2Zm12.056-12V0h-2v.001h2Zm-1 .999v-2 2Zm-1-1v.002h2V0h-2Zm0 .002c0 6.586 5.328 11.925 11.917 12l.023-2c-5.505-.063-9.94-4.52-9.94-10h-2Zm11.917 10c-6.589.074-11.915 5.413-11.916 11.998h2c0-5.479 4.435-9.936 9.94-9.999l-.024-2ZM11.057 21v2-2ZM0 12.002c5.559 0 10.056 4.48 10.057 9.998h2C12.056 15.368 6.653 10.002 0 10.002v2Zm0 0v-2 2Zm1-1V11h-2 2Z"
      mask="url(#a)"
    />
  </Svg>
)
export default DiamondIconv2
